import moment from 'moment'
import { cloneDeep, get, isBoolean, isNumber, isString } from 'lodash'
import { isArrayComponent, isObjectComponent } from '../utils/index'

const Plugin = {
  install (Vue, options) {
    /**
     * Desabilita visualização do componente
     * @param  {Object} component [description]
     * @param  {Object} components [description]
     * @param  {Object} variables [description]
     * @param  {Object} json [description]
     * @return {Boolean}          [description]
     */
    Vue.prototype.$checkConditionalViewAllow = function (component, components, variables, json, readOnly) {
      // ocultar
      let hidden = false

      // Verifica se o componente possui a propriedade hidden
      if (!component.hasOwnProperty('rule')) return hidden
      if (!component.rule.hasOwnProperty('hidden')) return hidden

      // Atualiza a variavel com o valor atual do hidden
      hidden = component.rule.hidden

      // Verifica se não é obrigatório
      if (!hidden) return hidden

      // Obrigatoriedade condicional
      // Verifica se o componente possui as propriedades necessárias
      if (!component.rule.hasOwnProperty('hiddenConditional')) return hidden
      if (!component.rule.hiddenConditional.length) return hidden

      let hiddenConditional = component.rule['hiddenConditional']

      const methodTypeWhen = {
        component: (rule) => typeWhenComponent(rule),
        variable: (rule) => typeWhenVariable(rule)
      }

      const methodTypeCondition = {
        custom: (rule) => checkTypeConditionCustom(rule),
        initial: (rule) => checkTypeConditionInitial(rule),
        component: (rule) => checkTypeConditionComponent(rule),
        variable: (rule) => checkTypeConditionVariable(rule),
        json: (rule) => checkTypeConditionJson(rule),
        today: (rule) => checkTypeConditionToday(rule),
        daysBeforeNow: (rule) => checkTypeConditionDaysBeforeNow(rule),
        daysAfterNow: (rule) => checkTypeConditionDaysAfterNow(rule),
        monthsBeforeNow: (rule) => checkTypeConditionMonthsBeforeNow(rule),
        monthsAfterNow: (rule) => checkTypeConditionMonthsAfterNow(rule),
        yearsBeforeNow: (rule) => checkTypeConditionYearsBeforeNow(rule),
        yearsAfterNow: (rule) => checkTypeConditionYearsAfterNow(rule)
      }

      const methodTypeValue = {
        string: (value) => validTypeValueString(value),
        boolean: (value) => validTypeValueBoolean(value),
        number: (value) => validTypeValueNumber(value),
        date: (value) => validTypeValueDate(value),
        array: (value) => validTypeValueArray(value)
      }

      const typeWhenComponent = (rule) => {
        const c = this.$findComponentByKey(rule.when, components)

        if (c) {
          rule.when = cloneDeep(c)

          return methodTypeCondition[rule.typeCondition](rule)
        }
      }
      const typeWhenVariable = (rule) => {
        // Verifica se a ariavel existe nas variaveis injetadas
        if (variables.hasOwnProperty(rule.when)) {
          // Atualiza p valor do when com o valor da variavel existente nas variaveis injetadas
          rule.when = cloneDeep(variables[rule.when])

          return methodTypeCondition[rule.typeCondition](rule)
        }
      }

      const convertStringToDate = (value) => {
        const dateFormatList = [
          'DDMMyyyy',
          'DDMMYYYY',
          'YYYY-MM-DD',
          'yyyyMMDD'
        ]
        for (let i = 0; i < dateFormatList.length; i++) {
          const d = moment(value, dateFormatList[i])
          if (d.isValid() && d.format(dateFormatList[i]) === value) {
            return d
          }
        }

        return false
      }

      const getValueFromData = (data) => {
        if (readOnly) {
          return data.currentValue || data.defaultValue
        }
        return data.currentValue
      }

      const checkTypeConditionCustom = (rule) => {
        let x, y
        let type = rule.typeValue
        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            if (x) {
              if (isObjectComponent(rule.when)) {
                x = x.value
              }
              if (isArrayComponent(rule.when)) {
                if (x && x.length > 0) {
                  x = x.map(item => item.value)
                  type = 'array'
                } else {
                  return false
                }
              }
            }
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // validação para o type value date
        switch (type) {
          case 'date': {
            // valida o tipo do valor
            if (!methodTypeValue[rule.typeValue](x)) return false
            if (!methodTypeValue[rule.typeValue](y)) return false
            // converte em data
            if (x) x = convertStringToDate(x)
            if (y) y = convertStringToDate(y)

            if (!x || !y) {
              return this.$comparing(x, rule.operator, y)
            } else {
              return this.$comparingDate(x, rule.operator, y)
            }
            break
          }
          case 'array': {
            if (!methodTypeValue[rule.typeValue](y)) return false
            let result = false
            for (let item of x) {
              if (!methodTypeValue[rule.typeValue](item)) continue
              result = this.$comparing(item, rule.operator, y)
              if (result) {
                return result
              }
            }
            return result
            break
          }
          default: {
            // valida o tipo do valor
            return this.$comparing(x, rule.operator, y)
            break
          }
        }
      }
      const checkTypeConditionInitial = (rule) => {
        let x, y
        let type = rule.typeValue

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            y = rule.when.data.initialValue
            break
          default:
            return false
        }

        if ((x && x.length > 0) && (y && y.length > 0)) {
          if (isObjectComponent(rule.when)) {
            x = x.value
            y = y.value
          }
          if (isArrayComponent(rule.when)) {
            x = x.map(item => item.value)
            y = y.map(item => item.value)
            type = 'array'
          }
        } else {
          return false
        }

        // validação para o type value date
        switch (type) {
          case 'date': {
            // valida o tipo do valor
            if (!methodTypeValue[rule.typeValue](x)) return false
            if (!methodTypeValue[rule.typeValue](y)) return false

            // converte em data
            if (x) x = convertStringToDate(x)
            if (y) y = convertStringToDate(y)

            if (!x || !y) {
              return this.$comparing(x, rule.operator, y)
            } else {
              return this.$comparingDate(x, rule.operator, y)
            }
            break
          }
          case 'array': {
            let result = false
            for (let itemX of x) {
              if (!methodTypeValue[rule.typeValue](itemX)) continue
              for (let itemY of y) {
                if (!methodTypeValue[rule.typeValue](itemY)) continue
                result = this.$comparing(itemX, rule.operator, itemY)
                if (result) {
                  return result
                }
              }
            }
            return result
            break
          }
          default: {
            // valida o tipo do valor
            if (!methodTypeValue[rule.typeValue](x)) return false
            if (!methodTypeValue[rule.typeValue](y)) return false
            return this.$comparing(x, rule.operator, y)
            break
          }
        }
      }
      const checkTypeConditionComponent = (rule) => {
        let x, y
        const component = this.$findComponentByKey(rule.value, components)

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            if (isObjectComponent(rule.when)) {
              x = x.value
            }
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        if (!component) return false
        y = component.data.currentValue
        if (isObjectComponent(component)) {
          y = y.value
        }

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false
        if (!methodTypeValue[rule.typeValue](y)) return false

        // validação para o type value date
        if (rule.typeValue === 'date') {
          // converte em data
          if (x) x = convertStringToDate(x)
          if (y) y = convertStringToDate(y)

          if (!x || !y) {
            return this.$comparing(x, rule.operator, y)
          } else {
            return this.$comparingDate(x, rule.operator, y)
          }
        } else {
          return this.$comparing(x, rule.operator, y)
        }
      }
      const checkTypeConditionVariable = (rule) => {
        let x, y

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            if (isObjectComponent(rule.when)) {
              x = x.value
            }
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value
        if (!variables.hasOwnProperty(y)) return false
        y = variables[y]

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false
        if (!methodTypeValue[rule.typeValue](y)) return false

        // validação para o type value date
        if (rule.typeValue === 'date') {
          // converte em data
          if (x) x = convertStringToDate(x)
          if (y) y = convertStringToDate(y)

          if (!x || !y) {
            return this.$comparing(x, rule.operator, y)
          } else {
            return this.$comparingDate(x, rule.operator, y)
          }
        } else {
          return this.$comparing(x, rule.operator, y)
        }
      }
      const checkTypeConditionJson = (rule) => {
        let x, y

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            if (isObjectComponent(rule.when)) {
              x = x.value
            }
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        let array = y.split('.')
        for (var i = 0; i < array.length; i++) {
          switch (array[i]) {
            case 'json':
              y = json
              break
            case 'formData':
              y = formData
              break
            default:
              y = get(y, array[i])
          }
        }

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false
        if (!methodTypeValue[rule.typeValue](y)) return false

        // validação para o type value date
        if (rule.typeValue === 'date') {
          // converte em data
          if (x) x = convertStringToDate(x)
          if (y) y = convertStringToDate(y)

          if (!x || !y) {
            return this.$comparing(x, rule.operator, y)
          } else {
            return this.$comparingDate(x, rule.operator, y)
          }
        } else {
          return this.$comparing(x, rule.operator, y)
        }
      }
      const checkTypeConditionToday = (rule) => {
        let x, y
        let today = moment().startOf('day').format('DDMMyyyy')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = today

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false
        if (!methodTypeValue[rule.typeValue](y)) return false

        // validação para o type value date
        if (rule.typeValue === 'date') {
          // converte em data
          if (x) x = convertStringToDate(x)
          if (y) y = convertStringToDate(y)

          if (!x || !y) {
            return this.$comparing(x, rule.operator, y)
          } else {
            return this.$comparingDate(x, rule.operator, y)
          }
        } else {
          return this.$comparing(x, rule.operator, y)
        }
      }
      const checkTypeConditionDaysBeforeNow = (rule) => {
        let x, y
        const today = moment().startOf('day')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false

        // converte em data
        if (x) x = convertStringToDate(x)
        if (!x) return false

        const days = Number(y)
        y = today.subtract(days, 'days')

        return this.$comparingDate(x, rule.operator, y)
      }
      const checkTypeConditionDaysAfterNow = (rule) => {
        let x, y
        const today = moment().startOf('day')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false

        // converte em data
        if (x) x = convertStringToDate(x)
        if (!x) return false

        const days = Number(y)
        y = today.add(days, 'days')

        return this.$comparingDate(x, rule.operator, y)
      }
      const checkTypeConditionMonthsBeforeNow = (rule) => {
        let x, y
        const today = moment().startOf('day')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false

        // converte em data
        if (x) x = convertStringToDate(x)
        if (!x) return false

        y = today.subtract(y, 'months')

        return this.$comparingDate(x, rule.operator, y)
      }
      const checkTypeConditionMonthsAfterNow = (rule) => {
        let x, y
        const today = moment().startOf('day')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false

        // converte em data
        if (x) x = convertStringToDate(x)
        if (!x) return false

        y = today.add(y, 'months')

        return this.$comparingDate(x, rule.operator, y)
      }
      const checkTypeConditionYearsBeforeNow = (rule) => {
        let x, y
        const today = moment().startOf('day')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false

        // converte em data
        if (x) x = convertStringToDate(x)
        if (!x) return false

        y = today.subtract(y, 'years')

        return this.$comparingDate(x, rule.operator, y)
      }
      const checkTypeConditionYearsAfterNow = (rule) => {
        let x, y
        const today = moment().startOf('day')

        // atualiza os valores
        switch (rule.typeWhen) {
          case 'component':
            x = getValueFromData(rule.when.data)
            break
          case 'variable':
            x = rule.when
            break
          default:
            return false
        }

        y = rule.value

        // valida o tipo do valor
        if (!methodTypeValue[rule.typeValue](x)) return false

        // converte em data
        if (x) x = convertStringToDate(x)
        if (!x) return false

        y = today.add(y, 'years')

        return this.$comparingDate(x, rule.operator, y)
      }

      // Metodos de validação de tipo de valor
      const validTypeValueString = (value) => {
        return isString(value)
      }
      const validTypeValueBoolean = (value) => {
        return isBoolean(value)
      }
      const validTypeValueNumber = (value) => {
        if (value === null) return true

        return isNumber(value)
      }
      const validTypeValueDate = (value) => {
        if (!value) return true
        return moment(value, 'DDMMyyyy', true).isValid()
      }

      const validTypeValueArray = (value) => {
        return Array.isArray(value)
      }

      const checkMethodTypeWhen = (rule) => {
        if (methodTypeWhen.hasOwnProperty(rule.typeWhen)) {
          return methodTypeWhen[rule.typeWhen](cloneDeep(rule)) ? 1 : 0
        }
        return 0
      }

      // Valida as regras da obrigatoriedade condicional
      const isValidHiddenConditionalRules = hiddenConditional.reduce((accumulatorRules, currentValueRules, indexRules, arrayRules) => {
        // Percorre as regras [E]
        let isValidCurrentValueRules = currentValueRules.reduce((accumulatorRule, currentValueRule, indexRule, arrayRule) => {
          // Verifica se existe metodo para o type when(component/variavel)
          if (methodTypeWhen.hasOwnProperty(currentValueRule.typeWhen)) {
            // utiliza o objeto methodTypeWhen[component/variavel] passando a regra corrente.
            return accumulatorRule + methodTypeWhen[currentValueRule.typeWhen](cloneDeep(currentValueRule))
          }

          return accumulatorRule
        }, 0)

        return accumulatorRules + (isValidCurrentValueRules === currentValueRules.length ? 1 : 0)
      }, 0)

      // Atualiza com o valor atual
      hidden = isValidHiddenConditionalRules > 0

      return hidden
    }

    /**
     * Registra uma única espera de evento em um único alvo.
     * addEventListener support for IE8
     * @param  {HTMLElement} element      Alvo
     * @param  {String}      eventName    Uma linha de texto que representa o tipo de evento a ser esperado.
     * @param  {Function}    eventHandler O objeto/função que recebe uma notificação quando um evento do tipo especificado ocorre.
     */
    Vue.prototype.$bindEvent = function (element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false)
      } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler)
      }
    }

    Vue.prototype.$findComponentByKey = function (key, components) {
      var result
      components.some(c => c.key === key && (result = c) || (result = this.$findComponentByKey(key, c.components || [])))
      return result
    }

    Vue.prototype.$comparing = function (x, operator, y) {
      switch (operator) {
        case '>':
          return x > y
        case '<':
          return x < y
        case '>=':
          return x >= y
        case '<=':
          return x <= y
        case '==':
          return x == y
        case '!=':
          return x != y
      }
    }

    Vue.prototype.$comparingDate = function (x, operator, y) {
      switch (operator) {
        case '>':
          return x.isAfter(y)
        case '<':
          return x.isBefore(y)
        case '>=':
          return x.isAfter(y) || x.isSame(y)
        case '<=':
          return x.isBefore(y) || x.isSame(y)
        case '==':
          return x.isSame(y)
        case '!=':
          return !x.isSame(y)
      }
    }
  }
}

export default Plugin
